import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Przełącznik trybu filtra: „—" / „preferowane" / „wymagane" (mapuje na `modes` w API).
// value: null | 'preferred' | 'required'. Domyślnie null („—").
// Krótka podpowiedź tłumaczy różnicę (wymagane odrzuca, preferowane podbija ocenę).
// Etykiety i podpowiedź ze słownika: tryb.preferred, tryb.required, tryb.podpowiedz.
const OPTIONS = [
  { v: 'preferred' },
  { v: 'required' },
];

const ModeToggle = ({ value = 'required', onChange, label }) => {
  const { t } = useTranslation('asystent');
  const [hintOpen, setHintOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setHintOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <div className="flex items-center gap-1.5" ref={ref}>
      <div role="radiogroup" aria-label={label ? t('tryb.aria', { label }) : t('tryb.aria_filtra')} className="inline-flex rounded-md border border-gray-200 overflow-hidden">
        {OPTIONS.map((o) => {
          const active = (value || 'required') === o.v;
          return (
            <button
              key={o.v}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => onChange(o.v)}
              className={`px-2 py-1 text-[11px] font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
                active ? 'bg-blue-600 text-white' : 'bg-white text-gray-500 hover:bg-gray-50'
              }`}
            >
              {t(`tryb.${o.v}`)}
            </button>
          );
        })}
      </div>
      <div className="relative">
        <button
          type="button"
          onClick={() => setHintOpen((v) => !v)}
          aria-label={t('tryb.co_oznaczaja')}
          className="w-4 h-4 flex items-center justify-center rounded-full border border-gray-300 text-[10px] text-gray-400 hover:text-blue-600 hover:border-blue-300"
        >
          ?
        </button>
        {hintOpen && (
          <div className="absolute right-0 top-6 z-20 w-56 rounded-lg border border-gray-200 bg-white p-2.5 text-[11px] leading-relaxed text-gray-600 shadow-lg">
            {t('tryb.podpowiedz')}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModeToggle;
